module.exports = __webpack_public_path__ + "static/media/regresar_seleccionado.352a3ddd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/SupervisorChat/regresar_seleccionado.svg
// module id = 1838
// module chunks = 0